// extracted by mini-css-extract-plugin
module.exports = {"root":"_3W3Kh","searchBoxInputContainer":"eLXt6","searchBoxBorderContainer":"_9rVNO","suggestionContainer":"rmm6k","newStyle":"_3uAAm"};